export default "__VITE_ASSET__MeVSYiHV__"